import React from 'react';
import styled from 'styled-components';
import { BodyText, FlexBox } from '@make-software/cspr-design';

import { PRODUCT_NAME } from 'app/constants';

export const ContentWrapperBottom = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    background: '#f2f3f5',
    width: '100%',
    flexDirection: ['row'],
    justifyContent: 'center',
    margin: '24px 0'
  })
);

export interface PageFooterProps {
  version?: string;
}

export const PageFooter = (props: PageFooterProps) => {
  return (
    <>
      <ContentWrapperBottom>
        <BodyText variation="darkGray" size={2}>
          {PRODUCT_NAME} version: {props.version} | Powered by Make
        </BodyText>
      </ContentWrapperBottom>
    </>
  );
};
